import { Button, Grid, Typography } from '@mui/material';
import { isEmpty, keys, map, max, toNumber } from 'lodash';
import React from 'react';

import { useConfirmation } from 'components/modals/ConfirmationContext';
import { SingleClusterIndexToNeighborhoodName } from './SingleClusterIndexToNeighborhoodName';

export interface MapClusterIndexToNeighborhoodNameProps {
  clusterAssignmentMap: Record<number, string>;
  setClusterAssignmentMap: React.Dispatch<React.SetStateAction<Record<number, string> | undefined>>;
  hasChanges?: boolean;
  metadata: {
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
  };
}

export const MapClusterIndexToNeighborhoodName: React.FC<MapClusterIndexToNeighborhoodNameProps> = ({
  clusterAssignmentMap,
  setClusterAssignmentMap,
  hasChanges,
  metadata,
}) => {
  const confirmWithModal = useConfirmation();
  return (
    <Grid container direction="column">
      {!isEmpty(clusterAssignmentMap) && metadata?.createdAt && (
        <Grid item container direction="column" spacing={0.5}>
          <Typography variant="caption" color="textSecondary">
            Created at: {new Date(metadata.createdAt).toLocaleString()} ({metadata.createdBy})
          </Typography>
          {metadata.updatedAt && metadata.updatedAt !== metadata.createdAt && (
            <Typography variant="caption" color="textSecondary">
              Last changed at: {new Date(metadata.updatedAt).toLocaleString()} ({metadata.updatedBy})
            </Typography>
          )}
        </Grid>
      )}
      <Grid item container direction="column" spacing={1} marginBlock={2}>
        {map(keys(clusterAssignmentMap), (genericCluster) => (
          <SingleClusterIndexToNeighborhoodName
            key={genericCluster}
            genericCluster={toNumber(genericCluster)}
            currentClusterAssignmentMap={clusterAssignmentMap}
            setClusterAssignmentMap={setClusterAssignmentMap}
          />
        ))}
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            setClusterAssignmentMap((currentMappings = clusterAssignmentMap) => ({
              ...currentMappings,
              [max([...map(keys(currentMappings), toNumber), -1]) + 1]: '',
            }))
          }
        >
          Add Cluster Mapping
        </Button>
        {hasChanges && (
          <Button
            variant="text"
            color="secondary"
            onClick={async () =>
              (await confirmWithModal({
                title: 'Are you sure?',
                text: 'All unsaved changes will be lost.',
              })) && setClusterAssignmentMap(undefined)
            }
          >
            Restore to Last Saved
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
